export const HOTJAR_VERSION = 6;
